import { LanguagePrime } from "@/utils/language-prime.util";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import AutoComplete from "primevue/autocomplete";
import Avatar from "primevue/avatar";
import Breadcrumb from "primevue/breadcrumb";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Checkbox from "primevue/checkbox";
import Editor from "primevue/editor";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import DialogService from "primevue/dialogservice";
import Dropdown from "primevue/dropdown";
import FileUpload from "primevue/fileupload";
import Image from "primevue/image";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputSwitch from "primevue/inputswitch";
import InputText from "primevue/inputtext";
import Menu from "primevue/menu";
import OrderList from "primevue/orderlist";
import Chart from "primevue/chart";
import OverlayPanel from "primevue/overlaypanel";
import Paginator from "primevue/paginator";
import Password from "primevue/password";
import ProgressBar from "primevue/progressbar";
import ProgressSpinner from "primevue/progressspinner";
import Panel from "primevue/panel";
import RadioButton from "primevue/radiobutton";
import Row from "primevue/row";
import ScrollPanel from "primevue/scrollpanel";
import Sidebar from "primevue/sidebar";
import TabPanel from "primevue/tabpanel";
import TabView from "primevue/tabview";
import Tag from "primevue/tag";
import Textarea from "primevue/textarea";
import TieredMenu from "primevue/tieredmenu";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import Skeleton from "primevue/skeleton";
import Chip from "primevue/chip";
import Listbox from "primevue/listbox";
import SelectButton from "primevue/selectbutton";
import Slider from "primevue/slider";

import { App } from "vue";

export default function setPrimeComponent(app: App): void {
  app.use(PrimeVue, { locale: LanguagePrime.languagePrime });
  app.use(ToastService);
  app.use(ConfirmationService);
  app.use(DialogService);
  app.directive("tooltip", Tooltip);
  app.component("Button", Button);
  app.component("Toast", Toast);
  app.component("Checkbox", Checkbox);
  app.component("OrderList", OrderList);
  app.component("RadioButton", RadioButton);
  app.component("Chart", Chart);
  app.component("Sidebar", Sidebar);
  app.component("Calendar", Calendar);
  app.component("Editor", Editor);
  app.component("Panel", Panel);
  app.component("Image", Image);
  app.component("Accordion", Accordion);
  app.component("AccordionTab", AccordionTab);
  app.component("Avatar", Avatar);
  app.component("Textarea", Textarea);
  app.component("TabView", TabView);
  app.component("Breadcrumb", Breadcrumb);
  app.component("TabPanel", TabPanel);
  app.component("FileUpload", FileUpload);
  app.component("Tag", Tag);
  app.component("ScrollPanel", ScrollPanel);
  app.component("ProgressSpinner", ProgressSpinner);
  app.component("ProgressBar", ProgressBar);
  app.component("DataTable", DataTable);
  app.component("Card", Card);
  app.component("ConfirmDialog", ConfirmDialog);
  app.component("AutoComplete", AutoComplete);
  app.component("InputSwitch", InputSwitch);
  app.component("Dialog", Dialog);
  app.component("Column", Column);
  app.component("ColumnGroup", ColumnGroup);
  app.component("OverlayPanel", OverlayPanel);
  app.component("Row", Row);
  app.component("Paginator", Paginator);
  app.component("Dropdown", Dropdown);
  app.component("TieredMenu", TieredMenu);
  app.component("InputMask", InputMask);
  app.component("Menu", Menu);
  app.component("InputPassword", Password);
  app.component("InputText", InputText);
  app.component("InputNumber", InputNumber);
  app.component("Skeleton", Skeleton);
  app.component("Chip", Chip);
  app.component("Listbox", Listbox);
  app.component("SelectButton", SelectButton);
  app.component("Slider", Slider);
}
